module.exports = "/_next/static/images/7a020f78f6b90ca6a476de65470e49cb-hero-md.jpg";